<template>
  <router-link :to="getRoutePath(programme)" class="card-link cursor-pointer">
    <div
      :id="'index_program_' + programme.id"
      class="yellow-bottom-card with-shadow programme-card"
    >
      <div class="flex flex-center">
        <q-img style="height: 100px; width: 180px" :src="getPhoto(programme)" />
      </div>
      <div class="institution-header flex flex-center">
        {{ getUniName(programme) }}
      </div>
      <div class="q-pa-md">
        <div class="programme-header">
          {{ getName(programme) }}
        </div>
        <div class="q-pt-md text-left inline-flex items-center">
          <q-icon name="book" color="secondary" size="24px" class="q-mr-sm" />
          {{ getType(programme) }}
        </div>
        <div class="q-pt-md text-left inline-flex items-center">
          <q-icon name="location_on" color="secondary" size="24px" class="q-mr-sm" />
          {{ getCity(programme) }}
        </div>
        <div class="q-pt-md text-left inline-flex items-center">
          <q-icon name="local_library" color="secondary" size="24px" class="q-mr-sm" />
          {{ getStudyModes(programme).join('/') }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { useProgrammeLocale } from 'src/composables/programme/useProgrammeLocale'
import type { ProgrammeListItem } from 'src/types/Programme'
import { useProgrammeRoute } from 'src/composables/programme/useProgrammeRoute'

defineProps<{
  programme: ProgrammeListItem
  index?: number
}>()

const { getName, getUniName, getPhoto, getType, getCity, getStudyModes } = useProgrammeLocale()

const { getRoutePath } = useProgrammeRoute()
</script>

<style lang="scss" scoped>
.programme-card {
  color: $primary;
  background-color: white;
  padding: 10px 0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-8px);
  }

  .institution-header {
    background-color: $secondary;
    color: white;
    padding: 4px;
    text-align: center;
    height: 50px;
  }

  .programme-header {
    text-align: left;
    color: $primary;
    font-size: 17px;
    font-weight: bolder;
    height: 90px;
  }
}
</style>
